function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { useParams, useSearch } from '@tanstack/react-router';
const parseNestedQuery = (search)=>{
    const result = {};
    for (const key of Object.keys(search)){
        const match = /^(\w+)\[(\w+)\]$/.exec(key);
        if (!match) continue;
        const [, group, field] = match;
        if (!group || !field) continue;
        if (!result[group]) result[group] = {};
        const raw = search[key];
        if (typeof raw === 'string' && raw.includes(',')) {
            result[group][field] = raw.split(',');
        } else if (typeof raw === 'string') {
            result[group][field] = raw;
        } else if (Array.isArray(raw) && raw.every((item)=>typeof item === 'string')) {
            result[group][field] = raw;
        }
    }
    return result;
};
/**
 * @deprecated Use `Route.useParams()` directly from your route instead. This provides better type safety as params are
 *   inferred from the route definition.
 * @example
 *   ```tsx
 *   // Before (deprecated):
 *   import { useTypedParams } from '@ui/routes';
 *   const { organization } = useTypedParams();
 *
 *   // After (preferred):
 *   import { Route } from './route'; // or wherever your route is defined
 *   const { organization } = Route.useParams();
 *   ```;
 */ export const useTypedParams = ()=>{
    const params = useParams({
        strict: false
    });
    const search = useSearch({
        strict: false
    });
    const nested = parseNestedQuery(search);
    return _object_spread({}, params, nested);
};
